import { render, staticRenderFns } from "./CompetenciesPage.vue?vue&type=template&id=40728e4a"
import script from "./CompetenciesPage.vue?vue&type=script&lang=js"
export * from "./CompetenciesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports